// Local libary
import { FundingFacade } from '@amwager/funding/data-access';
import { LoadService, UnsubscribeObservableService } from '@amwager/util';

// Angular libray
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertController } from '@ionic/angular/standalone';

// Third party
import { Subscription, takeUntil } from 'rxjs';
import { forEach } from 'lodash';
import { CommonModule } from '@angular/common';
import { CommonFacade } from '@amwager/data-access';

// from JS eProtect iFrame CDN
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let bitpay: any; // class

@Component({
  selector: 'feature-ion-crypto-currency',
  templateUrl: './crypto-currency.component.html',
  styleUrls: ['./crypto-currency.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CryptoCurrencyComponent extends UnsubscribeObservableService implements OnInit {

  private BIT_PAY_URL = 'https://bitpay.com/bitpay.js';

  cryptoCurrencyForm!: FormGroup;

  // convenience getter for easy access to form fields
  get formVal() { return this.cryptoCurrencyForm?.controls }

  amount!: number;

  private subsDepositCryptoCurrencyResponse!: Subscription;

  isDepositing = false;

  constructor(
    private readonly loadService: LoadService,
    private readonly formBuilder: FormBuilder,
    private readonly fundingFacade: FundingFacade,
    private readonly alertCtrl: AlertController,
    private readonly cdRef: ChangeDetectorRef,
    private readonly commonFacade: CommonFacade,
  ) {
    super();
  }

  ngOnInit() {
    // update branch
    this.loadBitPayScript();

    this.initForm();
    // this.formVal['amount']?.setValue(25);
    // this.amount = 25;
  }

  private initForm(): void {
    this.cryptoCurrencyForm = this.formBuilder.group({
      amount: ['', [Validators.required, Validators.minLength(25), Validators.maxLength(10000)]]
    });
  }

  depositAmount(): void {
    this.amount = this.formVal['amount']?.value;
  }

  deposit(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('CryptoCurrencyComponent:deposit', false);
      return;
    }

    if (this.cryptoCurrencyForm.valid && this.amount) {
      this.isDepositing = true;

      this.fundingFacade.depositCryptoCurrency(
        this.amount,
      );
      this.subsDepositCryptoCurrencyResponse = this.fundingFacade.isDepositCryptoCurrencySuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        // console.log(response);
        // console.log(isSuccess);
        if (!isSuccess && response !== undefined) {
          this.showAlertMessage('Deposit Error', response.error.Message);
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }


        this.subsDepositCryptoCurrencyResponse?.unsubscribe();

        if (isSuccess) {
          // console.log(bitpay);
          // bitpay.enableTestMode();
          // bitpay.showInvoice(response.InvoiceID);

          if (bitpay && bitpay.showInvoice) {
            this.openLink(response.InvoiceID);
          }

          // this.showAlertMessage('Success', 'Successfully Deposited Amount');
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }
      });
    }
    else {
      this.markFormGroupTouched(this.cryptoCurrencyForm);
    }
  }

  loadBitPayScript(): void {

    this.removeBitPayScript();

    const scriptsToAdd = [
      { id: 'bitPay', url: this.BIT_PAY_URL },
    ];

    this.loadService.addScripts(scriptsToAdd)
    .then(() => {
      console.log('Bitpay scripts added successfully!');

      this.cdRef.markForCheck();
    })
    .catch(error => {
      console.log('ERROR: Bitpay scripts loading failed:', error);

      this.cdRef.markForCheck();
    });
  }

  removeBitPayScript(): void {

    const scriptsToRemove = ['bitPay'];

    this.loadService.removeScripts(scriptsToRemove)
    .then(() => {
      console.log('Bitpay scripts removed successfully!');

      this.cdRef.markForCheck();
    })
    .catch(error => {
      console.log('ERROR: Bitpay scripts removal failed:', error);
    });
  }

  openLink(invoiceId: string): void {
    const cryptoCurrency = 'https://bitpay.com/invoice?id='+invoiceId+'&view=modal&v=4';

    window.open(cryptoCurrency,'Crypto Currency for Wagering', 'width=600, height=800');
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    forEach(formGroup.controls, (control) => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  async showAlertMessage(header: string, message: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header,
      message: message,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

}
